import { useTranslation } from "react-i18next";
import { Message } from "semantic-ui-react";

export default function NotFound() {
	const { t } = useTranslation();

	return <Message error>{t("notFound", "Not found")}</Message>;
}
